let arr = [
  {
    id: 'caoxi',
    name: '曹曦',
    job: '红杉资本中国基金合伙人',
    ting: 136,
    img1: require('@/assets/mingpian/caoxi.png'),
    img2: require('@/assets/touxiang/caoxi.png'),
    img3: require('@/assets/haibao_vx/caoxi.png'), 
    img4: require('@/assets/haibao_h5/caoxi.jpg'), 
    constellation: '水瓶座',
    bloodType: 'O型',
    info: '一个曾经想做科学家的投资人',
    problem: [
      {
        id: 'a1',
        title: '你最另类的爱好是什么',
        fabulous: false,                
        music: {
          speaking: false,           
          lang: 75,
          url: require('@/assets/caoxi/a1.mp3')
        },
        thumbs: 98,
      },{
        id: 'a3',
        title: '你的斜杠 idol 是谁',
        fabulous: false,                
        music: {
          speaking: false,           
          lang: 53,
          url: require('@/assets/caoxi/a3.mp3')
        },
        thumbs: 98,
      },{
        id: 'a5',
        title: '有没有触发你迈出斜杠第一步的一本书或一个 moment',
        fabulous: false,                
        music: {
          speaking: false,           
          lang: 58,
          url: require('@/assets/caoxi/a5.mp3')
        },
        thumbs: 98,
      },{
        id: 'a8',
        title: '你每天工作的驱动力是什么',
        fabulous: false,                
        music: {
          speaking: false,           
          lang: 92,
          url: require('@/assets/caoxi/a8.mp3')
        },
        thumbs: 98,
      },
    ]
  },{
    id: 'zhengqingsheng',
    name: '郑庆生',
    job: '红杉资本中国基金合伙人',
    ting: 136,
    img1: require('@/assets/mingpian/zhengqingsheng.png'),
    img2: require('@/assets/touxiang/zhengqingsheng.png'),
    img3: require('@/assets/haibao_vx/zhengqingsheng.png'),
    img4: require('@/assets/haibao_h5/zhengqingsheng.jpg'), 
    constellation: '金牛座',
    bloodType: 'O型',
    info: '爱好收集社会生活与商业历史的文章书籍',
    problem: [
      {
        id: 'a1',
        title: '你最另类的爱好是什么',
        fabulous: false,                
        music: {
          speaking: false,           
          lang: 57,
          url: require('@/assets/zhengqingsheng/a1.mp3')
        },
        thumbs: 98,
      },{
        id: 'b1',
        title: '为什么很多优秀的创业者都有斜杠倾向',
        fabulous: false,                
        music: {
          speaking: false,
          lang: 40,
          url: require('@/assets/zhengqingsheng/b1.mp3')
        },
        thumbs: 98,
      },{
        id: 'b3',
        title: '斜杠的哪种特质会成为你进行项目投资的评判依据',
        fabulous: false,                
        music: {
          speaking: false,           
          lang: 59,
          url: require('@/assets/zhengqingsheng/b3.mp3')
        },
        thumbs: 98,
      },{
        id: 'b4',
        title: '年轻人创业是否可以选择从斜杠试水',
        fabulous: false,                
        music: {
          speaking: false,           
          lang: 38,
          url: require('@/assets/zhengqingsheng/b4.mp3')
        },
        thumbs: 98,
      },{
        id: 'b5',
        title: '拥有斜杠特质在你了解客户、服务客户过程中发挥哪些重要价值',
        fabulous: false,                
        music: {
          speaking: false,           
          lang: 31,
          url: require('@/assets/zhengqingsheng/b5.mp3')
        },
        thumbs: 98,
      },
    ]
  },{
    id: 'dili',
    name: '迪力',
    job: '红杉资本中国基金投资经理',
    ting: 136,
    img1: require('@/assets/mingpian/dili.png'),
    img2: require('@/assets/touxiang/dili.png'),
    img3: require('@/assets/haibao_vx/dili.png'),
    img4: require('@/assets/haibao_h5/dili.jpg'), 
    constellation: '天秤座',
    bloodType: 'A型',
    info: '不在能知 乃在能行',
    problem: [
      {
        id: 'a1',
        title: '你最另类的爱好是什么',
        fabulous: false,                
        music: {
          speaking: false,           
          lang: 74,
          url: require('@/assets/dili/a1.mp3')
        },
        thumbs: 98,
      },{
        id: 'a7',
        title: '你觉得自己的使命是啥',
        fabulous: false,                
        music: {
          speaking: false,           
          lang: 45,
          url: require('@/assets/dili/a7.mp3')
        },
        thumbs: 98,
      },{
        id: 'a8',
        title: '你每天工作的驱动力是什么',
        fabulous: false,                
        music: {
          speaking: false,           
          lang: 68,
          url: require('@/assets/dili/a8.mp3')
        },
        thumbs: 98,
      },{
        id: 'b1',
        title: '为什么很多优秀的创业者都有斜杠倾向',
        fabulous: false,                
        music: {
          speaking: false,           
          lang:59,
          url: require('@/assets/dili/b1.mp3')
        },
        thumbs: 98,
      },{
        id: 'b7',
        title: '初创公司怎样才能杀出重围，脱颖而出',
        fabulous: false,                
        music: {
          speaking: false,           
          lang: 73,
          url: require('@/assets/dili/b7.mp3')
        },
        thumbs: 98,
      },
    ]
  },{
    id: 'zhangxinyuan',
    name: '张馨苑',
    job: '红杉资本中国基金投资经理',
    ting: 136,
    img1: require('@/assets/mingpian/zhangxinyuan.png'),
    img2: require('@/assets/touxiang/zhangxinyuan.png'),
    img3: require('@/assets/haibao_vx/zhangxinyuan.png'),
    img4: require('@/assets/haibao_h5/zhangxinyuan.jpg'), 
    constellation: '狮子座',
    bloodType: 'A型',
    info: '希望能与眼里有光的技术创业者识于微时，共同成长',
    problem: [
      {
        id: 'a4',
        title: '斜杠经历带来的哪些微小改变，让你的人生产生了大变化',
        fabulous: false,                
        music: {
          speaking: false,           
          lang: 43,
          url: require('@/assets/zhangxinyuan/a4.mp3')
        },
        thumbs: 98,
      },{
        id: 'b1',
        title: '为什么很多优秀的创业者都有斜杠倾向',
        fabulous: false,                
        music: {
          speaking: false,           
          lang: 11,
          url: require('@/assets/zhangxinyuan/b1.mp3')
        },
        thumbs: 98,
      },{
        id: 'b5',
        title: '拥有斜杠特质在你投资过程中发挥哪些重要价值',
        fabulous: false,                
        music: {
          speaking: false,           
          lang: 37,
          url: require('@/assets/zhangxinyuan/b5.mp3')
        },
        thumbs: 98,
      },
    ]
  },{
    id: 'penny',
    name: '邓珩Penny',
    job: '红杉资本中国基金分析师',
    ting: 136,
    img1: require('@/assets/mingpian/penny.png'),
    img2: require('@/assets/touxiang/penny.png'),
    img3: require('@/assets/haibao_vx/penny.png'),
    img4: require('@/assets/haibao_h5/penny.jpg'), 
    constellation: '水瓶座',
    bloodType: 'O型',
    info: '红杉周冬雨',
    problem: [
      {
        id: 'a1',
        title: '你最另类的爱好是什么',
        fabulous: false,                
        music: {
          speaking: false,           lang: 193,
          url: require('@/assets/penny/a1.mp3')
        },
        thumbs: 98,
      },{
        id: 'a5',
        title: '有没有触发你迈出斜杠第一步的一本书或一个 moment',
        fabulous: false,                
        music: {
          speaking: false,           lang: 75,
          url: require('@/assets/penny/a5.mp3')
        },
        thumbs: 98,
      },{
        id: 'b1',
        title: '为什么很多优秀的创业者都有斜杠倾向',
        fabulous: false,                
        music: {
          speaking: false,           lang: 107,
          url: require('@/assets/penny/b1.mp3')
        },
        thumbs: 98,
      },{
        id: 'b7',
        title: '初创公司怎样才能杀出重围，脱颖而出',
        fabulous: false,                
        music: {
          speaking: false,           lang: 53,
          url: require('@/assets/penny/b7.mp3')
        },
        thumbs: 98,
      },
    ]
  },{
    id: 'suchunyuan',
    name: '苏春园',
    job: '观远数据创始人&CEO',
    ting: 136,
    img1: require('@/assets/mingpian/suchunyuan.png'),
    img2: require('@/assets/touxiang/suchunyuan.png'),
    img3: require('@/assets/haibao_vx/suchunyuan.png'),
    img4: require('@/assets/haibao_h5/suchunyuan.jpg'), 
    constellation: '金牛座',
    bloodType: 'A型',
    info: 'To B的创业逻辑很朴素：以客户价值为导向，反复雕琢，不断进化。大处着眼，小处着手，自然是时间的朋友。',
    problem: [
      {
        id: 'a1',
        title: '你最另类的爱好是什么',
        fabulous: false,                
        music: {
          speaking: false,           lang: 86,
          url: require('@/assets/suchunyuan/a1.mp3')
        },
        thumbs: 98,
      },{
        id: 'a3',
        title: '你的斜杠 idol 是谁',
        fabulous: false,                
        music: {
          speaking: false,           lang: 153,
          url: require('@/assets/suchunyuan/a3.mp3')
        },
        thumbs: 98,
      },{
        id: 'a8',
        title: '你每天工作的驱动力是什么',
        fabulous: false,                
        music: {
          speaking: false,           lang: 150,
          url: require('@/assets/suchunyuan/a8.mp3')
        },
        thumbs: 98,
      },{
        id: 'b1',
        title: '为什么很多优秀的创业者都有斜杠倾向',
        fabulous: false,                
        music: {
          speaking: false,           lang: 110,
          url: require('@/assets/suchunyuan/b1.mp3')
        },
        thumbs: 98,
      },{
        id: 'b6',
        title: '斜杠特质是否让你在众多管理角色中穿梭自如',
        fabulous: false,                
        music: {
          speaking: false,           lang: 99,
          url: require('@/assets/suchunyuan/b6.mp3')
        },
        thumbs: 98,
      },
    ]
  },{
    id: 'zhengxiaoyue',
    name: '郑小岳',
    job: '阶形网络科技创始人&CEO',
    ting: 136,
    img1: require('@/assets/mingpian/zhengxiaoyue.png'),
    img2: require('@/assets/touxiang/zhengxiaoyue.png'),
    img3: require('@/assets/haibao_vx/zhengxiaoyue.png'),
    img4: require('@/assets/haibao_h5/zhengxiaoyue.jpg'), 
    constellation: '白羊座',
    bloodType: 'X型',
    info: '不会拍电影的码农不是好的创业者',
    problem: [
      {
        id: 'a1',
        title: '你最另类的爱好是什么',
        fabulous: false,                
        music: {
          speaking: false,           lang: 39,
          url: require('@/assets/zhengxiaoyue/a1.mp3')
        },
        thumbs: 98,
      },{
        id: 'a5',
        title: '有没有触发你迈出斜杠第一步的一本书或一个 moment',
        fabulous: false,                
        music: {
          speaking: false,           lang: 48,
          url: require('@/assets/zhengxiaoyue/a5.mp3')
        },
        thumbs: 98,
      },{
        id: 'a8',
        title: '你每天工作的驱动力是什么',
        fabulous: false,                
        music: {
          speaking: false,           lang: 40,
          url: require('@/assets/zhengxiaoyue/a8.mp3')
        },
        thumbs: 98,
      },{
        id: 'b1',
        title: '为什么很多优秀的创业者都有斜杠倾向',
        fabulous: false,                
        music: {
          speaking: false,           lang: 33,
          url: require('@/assets/zhengxiaoyue/b1.mp3')
        },
        thumbs: 98,
      },{
        id: 'b7',
        title: '初创公司怎样才能杀出重围，脱颖而出',
        fabulous: false,                
        music: {
          speaking: false,           lang: 39,
          url: require('@/assets/zhengxiaoyue/b7.mp3')
        },
        thumbs: 98,
      },
    ]
  },{
    id: 'wangping',
    name: '王平',
    job: '华筑科技创始人&CEO',
    ting: 136,
    img1: require('@/assets/mingpian/wangping.png'),
    img2: require('@/assets/touxiang/wangping.png'),
    img3: require('@/assets/haibao_vx/wangping.png'),
    img4: require('@/assets/haibao_h5/wangping.jpg'), 
    constellation: '双子座',
    bloodType: 'AB型',
    info: '一个想改变世界的创业者',
    problem: [
      {
        id: 'a1',
        title: '你最另类的爱好是什么',
        fabulous: false,                
        music: {
          speaking: false,           lang: 62,
          url: require('@/assets/wangping/a1.mp3')
        },
        thumbs: 98,
      },{
        id: 'b4',
        title: '年轻人创业是否可以选择从斜杠试水',
        fabulous: false,                
        music: {
          speaking: false,           lang: 76,
          url: require('@/assets/wangping/b4.mp3')
        },
        thumbs: 98,
      },{
        id: 'b7',
        title: '初创公司怎样才能杀出重围，脱颖而出',
        fabulous: false,                
        music: {
          speaking: false,           lang: 92,
          url: require('@/assets/wangping/b7.mp3')
        },
        thumbs: 98,
      },
    ]
  },{
    id: 'chenlong',
    name: '陈龙',
    job: '鳄梨科技创始人&CEO',
    ting: 136,
    img1: require('@/assets/mingpian/chenlong.png'),
    img2: require('@/assets/touxiang/chenlong.png'),
    img3: require('@/assets/haibao_vx/chenlong.png'),
    img4: require('@/assets/haibao_h5/chenlong.jpg'), 
    constellation: '水瓶座',
    bloodType: 'O型',
    info: 'Always respect and be yourself',
    problem: [
      {
        id: 'a1',
        title: '你最另类的爱好是什么',
        fabulous: false,                
        music: {
          speaking: false,           lang: 106,
          url: require('@/assets/chenlong/a1.mp3')
        },
        thumbs: 98,
      },{
        id: 'a3',
        title: '你的斜杠 idol 是谁',
        fabulous: false,                
        music: {
          speaking: false,           lang: 85,
          url: require('@/assets/chenlong/a3.mp3')
        },
        thumbs: 98,
      },{
        id: 'a6',
        title: '在斜杠创业路上，最让你兴奋的事情是什么',
        fabulous: false,                
        music: {
          speaking: false,           lang: 60,
          url: require('@/assets/chenlong/a6.mp3')
        },
        thumbs: 98,
      },{
        id: 'b2',
        title: '斜杠越来越流行，是必然趋势还是偶然现象',
        fabulous: false,                
        music: {
          speaking: false,           lang: 56,
          url: require('@/assets/chenlong/b2.mp3')
        },
        thumbs: 98,
      },{
        id: 'b3',
        title: '斜杠的哪种特质会成为你招聘员工的评判依据',
        fabulous: false,                
        music: {
          speaking: false,           lang: 50,
          url: require('@/assets/chenlong/b3.mp3')
        },
        thumbs: 98,
      },
    ]
  },{
    id: 'sangwenfeng',
    name: '桑文锋',
    job: '神策数据创始人&CEO',
    ting: 136,
    img1: require('@/assets/mingpian/sangwenfeng.png'),
    img2: require('@/assets/touxiang/sangwenfeng.png'),
    img3: require('@/assets/haibao_vx/sangwenfeng.png'),
    img4: require('@/assets/haibao_h5/sangwenfeng.jpg'), 
    constellation: '双子座',
    bloodType: 'A型',
    info: '追求做成一件大事，追求内心的强大，追求用积极和乐观感染周围的人',
    problem: [
      {
        id: 'a2',
        title: '你为自己热爱的事情(技术)做过什么疯狂的事情',
        fabulous: false,                
        music: {
          speaking: false,           lang: 80,
          url: require('@/assets/sangwenfeng/a2.mp3')
        },
        thumbs: 98,
      },{
        id: 'a5',
        title: '有没有触发你迈出斜杠第一步的一本书或一个 moment',
        fabulous: false,                
        music: {
          speaking: false,           lang: 46,
          url: require('@/assets/sangwenfeng/a5.mp3')
        },
        thumbs: 98,
      },{
        id: 'a7',
        title: '你觉得自己的使命是啥',
        fabulous: false,                
        music: {
          speaking: false,           lang: 21,
          url: require('@/assets/sangwenfeng/a7.mp3')
        },
        thumbs: 98,
      },{
        id: 'b1',
        title: '为什么很多优秀的创业者都有斜杠倾向',
        fabulous: false,                
        music: {
          speaking: false,           lang: 34,
          url: require('@/assets/sangwenfeng/b1.mp3')
        },
        thumbs: 98,
      },{
        id: 'b5',
        title: '拥有斜杠特质在你了解客户、服务客户过程中发挥哪些重要价值',
        fabulous: false,                
        music: {
          speaking: false,           lang: 39,
          url: require('@/assets/sangwenfeng/b5.mp3')
        },
        thumbs: 98,
      },
    ]
  },{
    id: 'dengyunze',
    name: '邓昀泽',
    job: '蓝猫微会创始人&CEO',
    ting: 136,
    img1: require('@/assets/mingpian/dengyunze.png'),
    img2: require('@/assets/touxiang/dengyunze.png'),
    img3: require('@/assets/haibao_vx/dengyunze.png'),
    img4: require('@/assets/haibao_h5/dengyunze.jpg'),
    constellation: '天秤座',
    bloodType: 'O型',
    info: '努力就是ROI最高的投资',
    problem: [
      {
        id: 'a7',
        title: '你觉得自己的使命是啥',
        fabulous: false,                
        music: {
          speaking: false,           lang: 77,
          url: require('@/assets/dengyunze/a7.mp3')
        },
        thumbs: 98,
      },{
        id: 'a8',
        title: '你每天工作的驱动力是什么',
        fabulous: false,                
        music: {
          speaking: false,           lang: 61,
          url: require('@/assets/dengyunze/a8.mp3')
        },
        thumbs: 98,
      },{
        id: 'b1',
        title: '为什么很多优秀的创业者都有斜杠倾向',
        fabulous: false,                
        music: {
          speaking: false,           lang: 73,
          url: require('@/assets/dengyunze/b1.mp3')
        },
        thumbs: 98,
      },{
        id: 'b7',
        title: '初创公司怎样才能杀出重围，脱颖而出',
        fabulous: false,                
        music: {
          speaking: false,           lang: 145,
          url: require('@/assets/dengyunze/b7.mp3')
        },
        thumbs: 98,
      },
    ]
  },{
    id: 'sijie',
    name: '斯杰',
    job: 'StreamNative创始人&CEO',
    ting: 136,
    img1: require('@/assets/mingpian/sijie.png'),
    img2: require('@/assets/touxiang/sijie.png'),
    img3: require('@/assets/haibao_vx/sijie.png'),
    img4: require('@/assets/haibao_h5/sijie.jpg'),
    constellation: '白羊座',
    bloodType: 'X型',
    info: 'Open source software eats everything.',
    problem: [
      {
        id: 'a1',
        title: '你最另类的爱好是什么',
        fabulous: false,                
        music: {
          speaking: false,           lang: 63,
          url: require('@/assets/sijie/a1.mp3')
        },
        thumbs: 98,
      },{
        id: 'a4',
        title: '斜杠经历带来的哪些微小改变，让你的人生产生了大变化',
        fabulous: false,                
        music: {
          speaking: false,           lang: 133,
          url: require('@/assets/sijie/a4.mp3')
        },
        thumbs: 98,
      },{
        id: 'a8',
        title: '你每天工作的驱动力是什么',
        fabulous: false,                
        music: {
          speaking: false,           lang: 210,
          url: require('@/assets/sijie/a8.mp3')
        },
        thumbs: 98,
      },{
        id: 'b1',
        title: '为什么很多优秀的创业者都有斜杠倾向',
        fabulous: false,                
        music: {
          speaking: false,           lang: 64,
          url: require('@/assets/sijie/b1.mp3')
        },
        thumbs: 98,
      },{
        id: 'b6',
        title: '斜杠特质是否让你在众多管理角色中穿梭自如',
        fabulous: false,                
        music: {
          speaking: false,           lang: 107,
          url: require('@/assets/sijie/b6.mp3')
        },
        thumbs: 98,
      },
    ]
  },{
    id: 'xubin',
    name: '徐彬',
    job: '小帮规划创始人&CEO',
    ting: 136,
    img1: require('@/assets/mingpian/xubin.png'),
    img2: require('@/assets/touxiang/xubin.png'),
    img3: require('@/assets/haibao_vx/xubin.png'),
    img4: require('@/assets/haibao_h5/xubin.jpg'),
    constellation: '摩羯座',
    bloodType: 'B型',
    info: '为了创业，可以从写800字作文都困难的理科生变身为3个月写100万字课程的作者',
    problem: [
      {
        id: 'a2',
        title: '你为自己热爱的事情(技术)做过什么疯狂的事情',
        fabulous: false,                
        music: {
          speaking: false,           lang: 26,
          url: require('@/assets/xubin/a2.mp3')
        },
        thumbs: 98,
      },{
        id: 'a3',
        title: '你的斜杠 idol 是谁',
        fabulous: false,                
        music: {
          speaking: false,           lang: 20,
          url: require('@/assets/xubin/a3.mp3')
        },
        thumbs: 98,
      },{
        id: 'b1',
        title: '为什么很多优秀的创业者都有斜杠倾向',
        fabulous: false,                
        music: {
          speaking: false,           lang: 35,
          url: require('@/assets/xubin/b1.mp3')
        },
        thumbs: 98,
      },{
        id: 'b3',
        title: '斜杠的哪种特质会成为你招聘员工的评判依据',
        fabulous: false,                
        music: {
          speaking: false,           lang: 15,
          url: require('@/assets/xubin/b3.mp3')
        },
        thumbs: 98,
      },
    ]
  },{
    id: 'wangxingxing',
    name: '王兴兴',
    job: '宇树科技创始人&CEO',
    ting: 136,
    img1: require('@/assets/mingpian/wangxingxing.png'),
    img2: require('@/assets/touxiang/wangxingxing.png'),
    img3: require('@/assets/haibao_vx/wangxingxing.png'),
    img4: require('@/assets/haibao_h5/wangxingxing.jpg'),
    constellation: '白羊座',
    bloodType: 'X型',
    info: '科技的洪流汹涌向前，我愿成那一叶方舟！',
    problem: [
      {
        id: 'a6',
        title: '在斜杠创业路上，最让你兴奋的事情是什么',
        fabulous: false,                
        music: {
          speaking: false,           lang: 18,
          url: require('@/assets/wangxingxing/a6.mp3')
        },
        thumbs: 98,
      },{
        id: 'a7',
        title: '你觉得自己的使命是啥',
        fabulous: false,                
        music: {
          speaking: false,           lang: 22,
          url: require('@/assets/wangxingxing/a7.mp3')
        },
        thumbs: 98,
      },{
        id: 'a8',
        title: '你每天工作的驱动力是什么',
        fabulous: false,                
        music: {
          speaking: false,           lang: 27,
          url: require('@/assets/wangxingxing/a8.mp3')
        },
        thumbs: 98,
      },{
        id: 'b2',
        title: '斜杠越来越流行，是必然趋势还是偶然现象',
        fabulous: false,                
        music: {
          speaking: false,           lang: 18,
          url: require('@/assets/wangxingxing/b2.mp3')
        },
        thumbs: 98,
      },{
        id: 'b3',
        title: '斜杠的哪种特质会成为你招聘员工的评判依据',
        fabulous: false,                
        music: {
          speaking: false,           lang: 23,
          url: require('@/assets/wangxingxing/b3.mp3')
        },
        thumbs: 98,
      },
    ]
  },{
    id: 'lijunfeng',
    name: '李俊峰',
    job: '店匠科技创始人&CEO',
    ting: 136,
    img1: require('@/assets/mingpian/lijunfeng.png'),
    img2: require('@/assets/touxiang/lijunfeng.png'),
    img3: require('@/assets/haibao_vx/wangxingxing.png'),
    img4: require('@/assets/haibao_h5/lijunfeng.jpg'),
    constellation: '蛇夫座',
    bloodType: 'O型',
    info: '不断重复去做一件事，是最有效的成功捷径',
    problem: [
      {
        id: 'a1',
        title: '你最另类的爱好是什么',
        fabulous: false,                
        music: {
          speaking: false,           lang: 56,
          url: require('@/assets/lijunfeng/a1.mp3')
        },
        thumbs: 98,
      },{
        id: 'a2',
        title: '你为自己热爱的事情(技术)做过什么疯狂的事情',
        fabulous: false,                
        music: {
          speaking: false,           lang: 43,
          url: require('@/assets/lijunfeng/a2.mp3')
        },
        thumbs: 98,
      },{
        id: 'a8',
        title: '你每天工作的驱动力是什么',
        fabulous: false,                
        music: {
          speaking: false,           lang: 47,
          url: require('@/assets/lijunfeng/a8.mp3')
        },
        thumbs: 98,
      },{
        id: 'b3',
        title: '斜杠的哪种特质会成为你招聘员工的评判依据',
        fabulous: false,                
        music: {
          speaking: false,           lang: 72,
          url: require('@/assets/lijunfeng/b3.mp3')
        },
        thumbs: 98,
      },{
        id: 'b7',
        title: '初创公司怎样才能杀出重围，脱颖而出',
        fabulous: false,                
        music: {
          speaking: false,           lang: 83,
          url: require('@/assets/lijunfeng/b7.mp3')
        },
        thumbs: 98,
      },
    ]
  },{
    id: 'songyimin',
    name: '宋一民',
    job: '数牍创始人&CEO',
    ting: 136,
    img1: require('@/assets/mingpian/songyimin.png'),
    img2: require('@/assets/touxiang/songyimin.png'),
    img3: require('@/assets/haibao_vx/wangxingxing.png'),
    img4: require('@/assets/haibao_h5/songyimin.jpg'),
    constellation: '狮子座',
    bloodType: 'AB型',
    info: '比想象的东西还珍贵的事物，一定会出现在追求它的过程里',
    problem: [
      {
        id: 'a2',
        title: '你为自己热爱的事情(技术)做过什么疯狂的事情',
        fabulous: false,                
        music: {
          speaking: false,           lang: 72,
          url: require('@/assets/songyimin/a2.mp3')
        },
        thumbs: 98,
      },{
        id: 'a4',
        title: '斜杠经历带来的哪些微小改变，让你的人生产生了大变化',
        fabulous: false,                
        music: {
          speaking: false,           lang: 50,
          url: require('@/assets/songyimin/a4.mp3')
        },
        thumbs: 98,
      },{
        id: 'b1',
        title: '为什么很多优秀的创业者都有斜杠倾向',
        fabulous: false,                
        music: {
          speaking: false,           lang: 67,
          url: require('@/assets/songyimin/b1.mp3')
        },
        thumbs: 98,
      },{
        id: 'b3',
        title: '斜杠的哪种特质会成为你进行项目投资或招聘员工的评判依据',
        fabulous: false,                
        music: {
          speaking: false,           lang: 38,
          url: require('@/assets/songyimin/b3.mp3')
        },
        thumbs: 98,
      },
    ]
  },



]
export default arr


// WEBPACK FOOTER //
// ./src/assets/data.js